import { __rest } from "tslib";
import * as React from 'react';
import Dropzone from 'react-dropzone';
import { FileUploadField } from './FileUploadField';
import { readFile, fileReaderType } from '../../helpers/fileUtils';
export var FileUpload = function FileUpload(_a) {
  var id = _a.id,
      type = _a.type,
      _a$value = _a.value,
      value = _a$value === void 0 ? type === fileReaderType.text || type === fileReaderType.dataURL ? '' : null : _a$value,
      _a$filename = _a.filename,
      filename = _a$filename === void 0 ? '' : _a$filename,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$onChange = _a.onChange,
      onChange = _a$onChange === void 0 ? function () {} : _a$onChange,
      _a$onReadStarted = _a.onReadStarted,
      onReadStarted = _a$onReadStarted === void 0 ? function () {} : _a$onReadStarted,
      _a$onReadFinished = _a.onReadFinished,
      onReadFinished = _a$onReadFinished === void 0 ? function () {} : _a$onReadFinished,
      _a$onReadFailed = _a.onReadFailed,
      onReadFailed = _a$onReadFailed === void 0 ? function () {} : _a$onReadFailed,
      _a$dropzoneProps = _a.dropzoneProps,
      dropzoneProps = _a$dropzoneProps === void 0 ? {} : _a$dropzoneProps,
      props = __rest(_a, ["id", "type", "value", "filename", "children", "onChange", "onReadStarted", "onReadFinished", "onReadFailed", "dropzoneProps"]);

  var onDropAccepted = function onDropAccepted(acceptedFiles, event) {
    if (acceptedFiles.length > 0) {
      var fileHandle = acceptedFiles[0];

      if (type === fileReaderType.text || type === fileReaderType.dataURL) {
        onChange('', fileHandle.name, event); // Show the filename while reading

        onReadStarted(fileHandle);
        readFile(fileHandle, type).then(function (data) {
          onReadFinished(fileHandle);
          onChange(data, fileHandle.name, event);
        }).catch(function (error) {
          onReadFailed(error, fileHandle);
          onReadFinished(fileHandle);
          onChange('', '', event); // Clear the filename field on a failure
        });
      } else {
        onChange(fileHandle, fileHandle.name, event);
      }
    }

    dropzoneProps.onDropAccepted && dropzoneProps.onDropAccepted(acceptedFiles, event);
  };

  var onDropRejected = function onDropRejected(rejectedFiles, event) {
    if (rejectedFiles.length > 0) {
      onChange('', rejectedFiles[0].name, event);
    }

    dropzoneProps.onDropRejected && dropzoneProps.onDropRejected(rejectedFiles, event);
  };

  var onClearButtonClick = function onClearButtonClick(event) {
    onChange('', '', event);
  };

  return React.createElement(Dropzone, Object.assign({
    multiple: false
  }, dropzoneProps, {
    onDropAccepted: onDropAccepted,
    onDropRejected: onDropRejected
  }), function (_ref) {
    var getRootProps = _ref.getRootProps,
        getInputProps = _ref.getInputProps,
        isDragActive = _ref.isDragActive,
        open = _ref.open;
    return React.createElement(FileUploadField, Object.assign({}, getRootProps(Object.assign(Object.assign({}, props), {
      refKey: 'containerRef',
      onClick: function onClick(event) {
        return event.preventDefault();
      } // Prevents clicking TextArea from opening file dialog

    })), {
      tabIndex: null,
      id: id,
      type: type,
      filename: filename,
      value: value,
      onChange: onChange,
      isDragActive: isDragActive,
      onBrowseButtonClick: open,
      onClearButtonClick: onClearButtonClick
    }), React.createElement("input", Object.assign({}, getInputProps())), children);
  });
};